<template>
  <div :class="['modalInfo', openClass]"  @keydown.stop.esc="closeModal">
    <div class="modalInfo__backdrop" @click.self="closeModal">
      <div class="modalInfo__wrapper" @keydown.prevent.tab="nextTabbable">
        <button class="modalInfo__close" @click="closeModal" aria-label="close" :data-modal-title="modalData.header" ref="close"></button>
        <div :class="['modalInfo__img-wrap', imgLoadedClass]" :style="{paddingBottom:imgRatio + '%'}">
          <img :src="modalData.img.url" :alt="modalData.img.alt" class="modalInfo__img" @load="handleImgLoad" @error="imageLoadError" >
        </div>

        <div class="modalInfo__content-wrap">
          <h3 class="modalInfo__header">{{modalData.header}}</h3>
          <div v-html="modalData.content" class="modalInfo__content">

          </div>
          <a :href="modalData.ctaLink" class="modalInfo__cta" v-if="modalData.ctaText !== ''">{{modalData.ctaText}}</a>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ModalInfo',
  components : {

  },
  data () {
    return {

        imgLoaded: false,
        imgSrc : '',
    }
  },
    computed:{
          openClass: function(){
              return this.isOpen ? 'modalInfo--open' : '';
          },
        imgLoadedClass: function(){
            return this.imgLoaded ? 'modalInfo__img-wrap--loaded' : '';
        },
        imgRatio : function(){
           // const img =
            return (this.modalData.img.height / this.modalData.img.width) * 100;
        },
    },
    mounted (){
     // console.log('modal mounted');
      this.$nextTick( ()=>{this.$refs.close.focus();} );
    },
  methods : {
      nextTabbable(e){
        //traps keyboard input in the dialog
        const tabbables = Array.from( this.$el.querySelectorAll('button, a, input, submit, textarea') ) //probably not an exhaustive list
            .filter( (el) => {
                return el !== e.target;
            });
        tabbables[0].focus();
      },
      handleImgLoad(){
          this.imgLoaded = true;
         // console.log('image loaded');
      },
      imageLoadError(){
          console.log('probs loading img');
      }
  },
  props :['isOpen', 'modalData', 'closeModal'],
}
</script>

<style scoped lang="scss">
.modalInfo__img-wrap {position: relative; width: 100%;}
.modalInfo__img{position: absolute; top:0; left: 0; width: 100%; height: auto;}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue